import { useMemo, useState } from 'react';
import { LoadingOutlined } from '@ant-design/icons';

const baseItemStyle = {
    width: '100%',
    border: 'none',
    background: 'transparent',
    padding: '12px 12px',
    borderRadius: 8,
    textAlign: 'left',
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    cursor: 'pointer',
    fontSize: 15,
    lineHeight: '22px',
    minHeight: 46,
    transition: 'background-color 0.16s ease, color 0.16s ease',
};

export function AppContextMenu({ open, position, items = [], onClose, minWidth = 220 }) {
    const [hoveredKey, setHoveredKey] = useState(null);

    const visibleItems = useMemo(
        () => (items || []).filter((item) => item && item.hidden !== true),
        [items]
    );

    if (!open || !position || visibleItems.length === 0) return null;

    return (
        <div
            style={{
                position: 'fixed',
                top: position.y,
                left: position.x,
                zIndex: 2000,
                minWidth,
                border: '1px solid rgba(15, 23, 42, 0.12)',
                borderRadius: 10,
                background: '#fff',
                boxShadow: '0 10px 35px rgba(2, 6, 23, 0.2)',
                padding: 8,
            }}
            onClick={(e) => e.stopPropagation()}
            onContextMenu={(e) => e.preventDefault()}
        >
            {visibleItems.map((item) => {
                const isHovered = hoveredKey === item.key;
                const isDanger = !!item.danger;
                const textColor = isDanger ? '#dc2626' : '#0f172a';
                const hoverTextColor = isDanger ? '#b91c1c' : '#0f172a';
                return (
                    <button
                        key={item.key}
                        type="button"
                        disabled={!!item.disabled}
                        style={{
                            ...baseItemStyle,
                            color: isHovered ? hoverTextColor : textColor,
                            background: isHovered
                                ? (isDanger ? 'rgba(220, 38, 38, 0.12)' : 'rgba(15, 23, 42, 0.06)')
                                : 'transparent',
                            opacity: item.disabled ? 0.55 : 1,
                            cursor: item.disabled ? 'not-allowed' : 'pointer',
                        }}
                        onMouseEnter={() => setHoveredKey(item.key)}
                        onMouseLeave={() => setHoveredKey(null)}
                        onClick={async () => {
                            if (item.disabled) return;
                            await item.onClick?.();
                            onClose?.();
                        }}
                    >
                        {item.loading ? <LoadingOutlined spin /> : item.icon}
                        {item.label}
                    </button>
                );
            })}
        </div>
    );
}

export default AppContextMenu;
